import { VisualizationTab } from './visualizationTab';

export const Graph = {
  VisualizationTab,
};
